import * as React from 'react';
import { Button } from 'react-bootstrap';
import '../sass/SideNav.css';
import { Icon } from 'react-icons-kit';
import {trophy} from 'react-icons-kit/fa/trophy'
import {pencil} from 'react-icons-kit/fa/pencil'
import UserNavMenu from './UserNavMenu';
import {barChart} from 'react-icons-kit/fa/barChart'
import {rocket} from 'react-icons-kit/fa/rocket'
import {cog} from 'react-icons-kit/fa/cog'
import {users} from 'react-icons-kit/fa/users'
// import {binoculars} from 'react-icons-kit/fa/binoculars'
// import {branch} from 'react-icons-kit/entypo/branch'
import {tree} from 'react-icons-kit/entypo/tree'

import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import AppUtils from '../utils/AppUtils';
import AppConfig from 'src/config/AppConfig';

export default class SideNav extends React.Component<any, any> {
    
    constructor(props:any) {
        super(props);

        this.state = {
            selectedMenuItem: 0,
        }

        // this.toggleLeaderboard = this.toggleLeaderboard.bind(this);
    }

    private gameMenuItemSelected() {
        this.props.toggleStoryEditPanel(false);
        this.props.toggleStoryViewPanel(false);
        this.props.toggleDataPanel(false);
        this.props.toggleLeaderboard(false);
        this.props.toggleSettings(false);
        this.setState({selectedMenuItem: 0});
    }

    private editMenuItemSelected() {
        this.props.toggleStoryEditPanel(true);
        this.props.toggleStoryViewPanel(false);
        this.props.toggleDataPanel(false);
        this.props.toggleLeaderboard(false);
        this.props.toggleSettings(false);
        this.setState({selectedMenuItem: 1});
    }

    private viewMenuItemSelected() {
        this.props.toggleStoryEditPanel(false);
        this.props.toggleStoryViewPanel(true);
        this.props.toggleDataPanel(false);
        this.props.toggleLeaderboard(false);
        this.props.toggleSettings(false);
        this.setState({selectedMenuItem: 2});
    }

    private scoresMenuItemSelected() {
        this.props.toggleStoryEditPanel(false);
        this.props.toggleStoryViewPanel(false);
        this.props.toggleDataPanel(false);
        this.props.toggleLeaderboard(true);
        this.props.toggleSettings(false);
        this.setState({selectedMenuItem: 3});
    }

    private dataMenuItemSelected() {
        this.props.toggleStoryEditPanel(false);
        this.props.toggleStoryViewPanel(false);
        this.props.toggleLeaderboard(false);
        this.props.toggleSettings(false);
        this.props.toggleDataPanel(true);
        this.setState({selectedMenuItem: 4});
    }

    private usersMenuItemSelected() {
        this.props.toggleStoryEditPanel(false);
        this.props.toggleStoryViewPanel(false);
        this.props.toggleDataPanel(false);
        this.props.toggleLeaderboard(false);
        this.props.toggleSettings(false);
        this.setState({selectedMenuItem: 5});
    }

    private settingsMenuItemSelected() {
        this.props.toggleStoryEditPanel(false);
        this.props.toggleStoryViewPanel(false);
        this.props.toggleDataPanel(false);
        this.props.toggleLeaderboard(false);
        this.props.toggleSettings(true);
        this.setState({selectedMenuItem: 6});
    }

    render() {
        return (
            <div className="navBtns">
            {
                this.props.loaded == true && AppUtils.isMobile == false && this.props.userData.admin == true ?
                <div>
                    <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="right" overlay={<Tooltip id="tooltip"><strong>Game</strong></Tooltip>}>
                        <Button className={this.state.selectedMenuItem == 0 ? 'navBtn navBtnActive' : 'navBtn'} onClick={this.gameMenuItemSelected.bind(this)}><Icon size={22} icon={rocket}/></Button>
                    </OverlayTrigger>
                    <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="right" overlay={<Tooltip id="tooltip"><strong>Edit</strong></Tooltip>}>
                        <Button className={this.state.selectedMenuItem == 1 ? 'navBtn navBtnActive' : 'navBtn'} onClick={this.editMenuItemSelected.bind(this)}><Icon size={22} icon={pencil}/></Button>
                    </OverlayTrigger>
                    <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="right" overlay={<Tooltip id="tooltip"><strong>View</strong></Tooltip>}>
                        <Button className={this.state.selectedMenuItem == 2 ? 'navBtn navBtnActive' : 'navBtn'} onClick={this.viewMenuItemSelected.bind(this)}><Icon size={25} icon={tree}/></Button>
                    </OverlayTrigger>
                    {/* <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="right" overlay={<Tooltip id="tooltip"><strong>Scores</strong></Tooltip>}>
                        <Button className={this.state.selectedMenuItem == 3 ? 'navBtn navBtnActive' : 'navBtn'} onClick={this.scoresMenuItemSelected.bind(this)}><Icon size={22} icon={trophy}/></Button>
                    </OverlayTrigger> */}
                    <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="right" overlay={<Tooltip id="tooltip"><strong>Data</strong></Tooltip>}>
                        <Button className={this.state.selectedMenuItem == 4 ? 'navBtn navBtnActive' : 'navBtn'} onClick={this.dataMenuItemSelected.bind(this)}><Icon size={22} icon={barChart}/></Button>
                    </OverlayTrigger>
                    {/* <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="right" overlay={<Tooltip id="tooltip"><strong>Users</strong></Tooltip>}>
                        <Button className={this.state.selectedMenuItem == 5 ? 'navBtn navBtnActive' : 'navBtn'} onClick={this.usersMenuItemSelected.bind(this)}><Icon size={22} icon={users}/></Button>
                    </OverlayTrigger> */}
                    <OverlayTrigger delay={AppConfig.TOOLTIP_DELAY} placement="right" overlay={<Tooltip id="tooltip"><strong>Settings</strong></Tooltip>}>
                        <Button className={this.state.selectedMenuItem == 6 ? 'navBtn navBtnActive' : 'navBtn'} onClick={this.settingsMenuItemSelected.bind(this)}><Icon size={22} icon={cog}/></Button>
                    </OverlayTrigger>
                </div> : null
            }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SideNav.tsx